import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import Wrapper from '../components/wrapper'
import SiteBox from '../components/site-box'
import AppBarInner from '../components/app-bar/AppBarInner'
import AppStepper from '../components/app-stepper'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import SettingList from '../components/setting-list'
import { LogoGa } from '../components/app-icon/Icons'
import FullScreenDialog from '../components/app-dialog'
import DataSetForm from '../components/app-form/DataSetForm'
import {ButtonContained, ButtonOutlined} from '../components/app-button/button'
import CustomizeAll from '../components/сustomize-all/'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  wizardContent: {
    maxWidth: 630,
    width: '100%',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '0 40px 30px 22px',
  },

  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    marginTop: 24,
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  finishBtn: {
    display: 'block',
    textDecoration: 'none',
    marginTop: 25,
    position: 'relative',
    left: 0,
    width: 160,
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: '100%',
      left: 14,
      height: 25,
      width: 1,
      backgroundColor: 'rgba(136, 102, 255, 0.2)',
    },
  },
})

function getSteps() {
  return [
    `Аккаунт \nподтвержден`,
    'Сайт \nдобавлен',
    'Настройте \nGoogle Analytics \nдля отображения \nрасширенных \nотчетов',
    'Добавьте каналы \nдля сбора данных \nо расходах',
    'Подключение CRM\nсистемы',
    'Подключение\nколлтрекинга',
  ]
}

class DataSet extends Component {
  state = {
    activeStep: 2,
    isFetching: false,
    site: window.state.site,
    client: window.state.google_analytics_client,
    accounts: window.state.google_analytics_accounts,
    datasets: window.state.google_analytics_datasets,
    errorMessage: window.state.errorMessage,
    isCard: window.state.cardTest,
  }

  render() {
    const { classes } = this.props
    const {
      site,
      client,
      accounts,
      datasets,
      errorMessage,
      isCard,
    } = this.state

    const steps = isCard ? getSteps() : getSteps().slice(0, -1)

    return (
      <div className={classes.pageTemplate}>
        <AppBarInner />
        <CustomizeAll />

        <div className={classes.wizardRow}>
          <LeftNavigationDashboard />

          <div style={{width: 200, position: 'relative'}}>
            <AppStepper activeStep={this.state.activeStep} steps={steps} />
            <a
              href="/wizard/ga/settings"
              className={classes.finishBtn}
            >
              <ButtonContained full={true} text="Назад"/>
            </a>
          </div>

          <div className={classes.wizardContent}>
            <SiteBox
              url={site.url}
              resource={site.name}
              gutterBottom={8}
              prevUrl={'/wizard/site'}
            />

            <Wrapper shadow={4}>
              <header className={classes.header}>
                <LogoGa className={classes.logoGa} />
              </header>

              <section className={classes.content}>
                <SettingList
                  {...client}
                  accounts={accounts}
                  prevUrl={'/wizard/ga/settings'}
                />

                {datasets && datasets.length ? (
                  <Dataset_ok
                    onSubmit={this.handleSubmit}
                    datasets={this.state.datasets}
                  />
                ) : null}

                {!datasets.length && errorMessage ? (
                  <Dataset_error
                    classes={classes}
                    errorMessage={errorMessage}
                  />
                ) : null}

                {!datasets.length && !errorMessage ? (
                  <Dataset_no classes={classes} />
                ) : null}
              </section>
            </Wrapper>
          </div>
        </div>
      </div>
    )
  }
}

const Dataset_no = ({ classes }) => (
  <React.Fragment>
    <Typography gutterBottom>
      Для окончания настройки GA для выбранного ресурса нужно добавить набор
      данных, в который будут экспортироваться затраты из рекламных сервисов.
    </Typography>
    <Typography
      variant="subtitle2"
      style={{ fontWeight: 600, fontSize: 14 }}
      gutterBottom
    >
      В вашем аккаунте набор данных не найден!
    </Typography>
    <Typography gutterBottom>
      Добавьте набор данных в Google Analytics, вернитесь на эту страницу и
      завершите настройку.
    </Typography>
    <ul className={classes.list}>
      <li className={classes.item}>
        <FullScreenDialog />
      </li>
    </ul>
    <ButtonOutlined
      style={{
        marginTop: 16,
      }}
      full={true}
      href={window.location.href}
      color="secondary"
      text="Проверить набор данных"
    />
  </React.Fragment>
)

const Dataset_error = ({ classes, errorMessage }) => (
  <React.Fragment>
    <Typography gutterBottom>
      Для окончания настройки GA для выбранного ресурса нужно добавить набор
      данных, в который будут экспортироваться затраты из рекламных сервисов.
    </Typography>
    <Typography
      variant="subtitle2"
      style={{ fontWeight: 600, fontSize: 14, color: 'red' }}
      gutterBottom
    >
      {errorMessage}
    </Typography>
  </React.Fragment>
)

class Dataset_ok extends Component {
  state = {
    datasets: window.state.google_analytics_datasets,
  }

  redirect = (nextUrl, status) => {
    if (status === 'ok') {
      location.href = nextUrl
    }
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/wizard/ga/dataset'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })
      .then(status)
      .then(json)
      .then(({ nextUrl, status }) => {
        this.timerId = setTimeout(() => this.redirect(nextUrl, status), 1000)
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  componentWillUnmount() {
    clearTimeout(this.timerId)
  }

  render() {
    const { datasets } = this.state
    const datasetsItem = datasets.filter(dataset => dataset.selected)

    return (
      <React.Fragment>
        <Typography variant="body2" paragraph>
          В этот “набор данных” будут экспортироваться данные о затратах из
          рекламных сервисов.
        </Typography>

        <DataSetForm
          isFetching={this.state.isFetching}
          onSubmit={this.handleSubmit}
          datasetsItem={datasetsItem}
          datasets={datasets}
          initialValues={
            !!(datasetsItem && datasetsItem.length)
              ? {
                  dataset: datasetsItem[0].id,
                }
              : null
          }
        />
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(DataSet)
